// @flow

import { Component } from '~/sources/scripts/jsti/core';
import EventNames from '../constants/EventNames';
import { isVisible } from '../classes/Helpers';

export default class ClickOutside extends Component {
  #clickHandler: function;
  #ignore: Array<HTMLElement>;

  /**
   * Instantiate the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);

    this.#clickHandler = this.onClick.bind(this);
    document.addEventListener(EventNames.CLICK, this.#clickHandler);

    try {
      let ignoreReferences: string[];

      try {
        ignoreReferences = JSON.parse(this.el.dataset.ignore);
      } catch {
        ignoreReferences = this.el.dataset.ignore ? this.el.dataset.ignore.split(' ') : [];
      }

      this.#ignore = ignoreReferences.map((reference: string) => [...document.getElementsByRef(reference)]).flat();
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Executes when anything in the document is clicked
   */
  onClick(event: Event): void {
    if (
      !isVisible(this.el) ||
      this.el === event.target ||
      this.el.contains(event.target) ||
      this.#ignore.includes(event.target) ||
      this.ignoreElementsContains(event.target)
    ) {
      return;
    }

    this.el.classList.add('hidden');
  }

  /**
   * Check whether the given ignore references contain the given target
   */
  ignoreElementsContains(target: HTMLElement): boolean {
    return !!this.#ignore.filter((element: HTMLElement) => element.contains(target)).length;
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    document.removeEventListener(EventNames.CLICK, this.#clickHandler);
  }
}
